import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
// import { ContactData } from "../Data/ContactData";
import { QRCodeSVG } from "qrcode.react";
import { color } from "../Utils/Constant";
import html2canvas from "html2canvas";
import { fetchUserData } from "../Utils/api";

// styles
const QRCodeContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding: 10px;
  padding-bottom: 20px;
`;
const DownloadQRCodeButton = styled.button`
  background-color: ${color.primary};
  padding: 8px 15px;
  color: ${color.white};
  border-radius: 5px;
  border: none;
  cursor: pointer;
`;

const QRCodeComp = ({ userName }) => {
  const qrRef = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
        const result = await fetchUserData(userName);
        setData(result[0]);
      } catch (error) {
        console.log("error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [userName]);

  const websiteUrl = data.website;

  const downloadQRCode = () => {
    if (!qrRef.current) return;
    html2canvas(qrRef.current).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "qr_code.png";
      link.click();
    });
  };

  if (loading) return <p>Loading...</p>;

  return (
    <QRCodeContainer>
      <div ref={qrRef}>
        {websiteUrl && <QRCodeSVG value={websiteUrl} size={200} />}
      </div>
      <DownloadQRCodeButton onClick={downloadQRCode}>
        Download QR Code
      </DownloadQRCodeButton>
    </QRCodeContainer>
  );
};

export default QRCodeComp;
